import { MessageCenterContext } from 'contexts/MessageCenterContext';
import { useContext } from 'react';

export const useMessageCenterContext = () => {
  const context = useContext(MessageCenterContext);
  if (context === undefined) {
    throw new Error('useMessageCenterContext must be used within a MessageCenterContextProvider');
  }
  return context;
};

export default useMessageCenterContext;
